/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import { API_TOKEN, API_URL, FNAD_PRODUCION_API } from "../../Config/secrets";
import { downloadExport } from "../../Utils";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  totalRetailers: 0,
  allRetailers: {},
  selectedFilters: {
    page: 1,
    filters: "",
  },
  filters: {},
  addWholeSaler: null,
  updateWholeSaler: null,
};

const slice = createSlice({
  name: "retailers",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    resetWholeSaler: () => initialState,
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSelectedFilters(state, action) {
      state.selectedFilters = action.payload;
    },
    getAllRetailerSuccess(state, action) {
      state.error = null;
      state.totalRetailers = action.payload.total;
      state.allRetailers = {
        ...state.allRetailers,
        [action.payload.page]: action.payload.data,
      };
      state.isLoading = false;
    },
    getAddWholeSalerSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.addWholeSaler = action.payload;
    },
    getUpdateWholeSalerSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.updateWholeSaler = action.payload;
    },
    getFiltersSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.filters = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getAddWholeSalerSuccess,
  getAllRetailerSuccess,
  getUpdateWholeSalerSuccess,
  resetWholeSaler,
  setSelectedFilters,
} = slice.actions;

// ----------------------------------------------------------------------

const header = {
  Authorization: API_TOKEN,
};

export function assignRetailerToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/retailers/assign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Retailer Company Updated");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function UnassignRetailerToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/retailers/unassign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Retailer Un-assigned to company");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}


export function addWholeSalerFunc(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${FNAD_PRODUCION_API}/retailers/create_wholesaler`, data, {
        headers: header,
      });

      if (response.status === 200) {
        toast.success("Wholesaler Created", { autoClose: 3000 });
      }
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error creating wholesaler", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

export function updateRetailerMatches({ data, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/retailers/update-retailer-matches`, data, {
        headers: header,
      });
      if (cb) {
        cb()
      }
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getFilters() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/retailers/data-to-filter-overall`, {
        headers: header,
      });

      if (response?.statusCode === 400 && !response?.data) {
        toast.error(response?.message || "Something went wrong", { autoClose: 3000 });
        return;
      }

      if (response?.data?.statusCode === 200) {
        dispatch(slice.actions.getFiltersSuccess(response?.data?.data));
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response));
      return error?.response;
    }
  };
}

export function addWholeSalerFuncViaFile(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${FNAD_PRODUCION_API}/retailers/create_wholesaler_with_file`, data, {
        headers: header,
      });

      dispatch(slice.actions.getAddWholeSalerSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error uploading file", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

export function updateRetailer({ data, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/retailers/update`, data, {
        headers: header,
      });
      console.log(data, response)

      if (response?.data?.statusCode === 200) {
        if (typeof cb === 'function') {
          cb()
        }
        toast.success("Retailer Updated", { autoClose: 3000 });
      }
      if (response.data?.statusCode >= 400) {
        toast.error(response?.data?.message);
      }
      dispatch(slice.actions.getUpdateWholeSalerSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      console.log('er', error)
      toast.error(error?.response?.data?.message || "Error updating retailer", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}

// Request body for the retailers table; the Excel export sends the same one.
function retailersListPayload(page, filters, query, take, source, brand_id, createdDateRange, updatedDateRange) {
  let payload = { skip: page, take };
  const isFilters = Object.keys(filters || {}).length > 0;

  if (isFilters) {
    payload.filters = true;
    payload = { ...payload, ...filters };
  }
  if (query) payload.query = query;
  if (source) payload.source = source;
  if (brand_id) payload.exclude_brand_id_matches = brand_id;
  if (createdDateRange?.startDate) payload.createdStartDate = createdDateRange.startDate;
  if (createdDateRange?.endDate) payload.createdEndDate = createdDateRange.endDate;
  if (updatedDateRange?.startDate) payload.updatedStartDate = updatedDateRange.startDate;
  if (updatedDateRange?.endDate) payload.updatedEndDate = updatedDateRange.endDate;
  return payload;
}

// Every retailer matching the table's current search/filters/dates, as .xlsx.
export function exportRetailers(filters, query, createdDateRange = null, updatedDateRange = null) {
  return async () => {
    const payload = retailersListPayload(1, filters, query, 10, null, null, createdDateRange, updatedDateRange);
    return downloadExport(`${API_URL}/retailers/export`, payload, header, `retailers_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };
}

export function getAllRetailers(page = 1, filters, query, take = 10, source = null, brand_id = null, createdDateRange = null, updatedDateRange = null) {
  return async (dispatch) => {
    try {
      const payload = retailersListPayload(page, filters, query, take, source, brand_id, createdDateRange, updatedDateRange);

      const response = await axios.post(`${API_URL}/retailers/get-overall`, payload, {
        headers: header,
      });

      // console.log('GET WHOLESALERS', response.data)
      // if (response?.data?.statusCode === 200) {
      dispatch(
        slice.actions.getAllRetailerSuccess({
          page,
          total: response?.data?.data?.count || 0,
          data: response?.data?.data?.data || [],
        })
      );
      return response?.data?.data?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getFilteredWholesaler(page = 1, query, filter, limit = 10) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${FNAD_PRODUCION_API}/retailers/get_filtered_wholesalers?page=${page}&limit=${limit}&filter=${filter || "New to old"}&search=${query || ""}`,
        {
          headers: header,
        }
      );

      if (response?.data?.status === 200) {
        dispatch(
          slice.actions.getAllRetailerSuccess({
            page,
            total: response?.data?.data?.total,
            data: response?.data?.data?.wholesalers,
          })
        );
        return response?.data?.data?.brands;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Error fetching filtered data", { autoClose: 3000 });
      return error?.response?.data;
    }
  };
}



export function deleteRetailer(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/retailers/delete`, data, {
        headers: header,
      });
      console.log("Retailers Delete RESPONSE", response);

      if (response.data?.statusCode >= 400) {
        toast.error(response?.data?.message);
      }

      if (response?.data?.statusCode === 200 && response?.data?.data) {
        toast.success(response?.data?.message);
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}
